import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import cl from '../classnames.scss'
import s from './group-card.scss'
import {GroupImage} from './group-image'
import {GroupCardProps} from './interfaces'
import {JoinButton} from './join-button'

export const GroupCard = ({
  className,
  title,
  eventTitle,
  image,
  joinGroup,
  membersCount,
  updatesCount,
  t,
}: GroupCardProps) => {
  const hasUpdatesOrLoading = updatesCount !== 0

  return (
    <div className={classNames(s.root, className)}>
      <div className={classNames(s.privacy, cl.textFont, s.text)}>
        {t('groups.cardSuggestion', {eventTitle, interpolation: {escapeValue: false}})}
      </div>
      <div className={classNames(s.card, {[s.noImage]: !image})}>
        {image ? <GroupImage image={image} className={s.image} /> : null}
        <div className={s.description}>
          <h4 className={classNames(s.title, cl.textFont, s.text)}>{title}</h4>
          {membersCount || hasUpdatesOrLoading ? (
            <div className={classNames(s.activity, cl.textFont, s.text)}>
              {membersCount
                ? membersCount > 1
                  ? t('groups.members.plural', {membersCount})
                  : t('groups.members.singular')
                : null}
              {membersCount && hasUpdatesOrLoading ? <> &#183; </> : ''}
              {hasUpdatesOrLoading
                ? updatesCount === 1
                  ? t('groups.activity.singular')
                  : t('groups.activity.plural', {updatesCount: updatesCount || '-'})
                : null}
            </div>
          ) : null}
        </div>
        <div className={s.cta}>
          <JoinButton className={s.button} onClick={() => joinGroup()} dataHook={DH.GROUPS_JOIN_BUTTON}>
            {t('groups.joinButton')}
          </JoinButton>
        </div>
      </div>
    </div>
  )
}
